import React from 'react';
export function PainPoints() {
  const points = ['El domingo a la noche buscando cómo explicar el FCR o el ciclo del nitrógeno con un lenguaje que tus alumnos entiendan sin dormirse', 'Estudiantes que salen del curso sin saber distinguir una trucha de un bagre ni calcular la tasa de alimentación de un estanque', 'Material que no se corresponde con las especies, los sistemas ni los mercados donde tus alumnos van a trabajar', 'Fines de semana enteros armando planillas, tablas de alimentación y evaluaciones que nadie te enseñó a diseñar', 'Esa sensación de que estás improvisando en un sector donde una mala decisión técnica puede significar la pérdida de todo el lote'];
  return <section className="py-8 px-4 bg-brand-cream" data-id="element-124">
      <div className="max-w-3xl mx-auto" data-id="element-125">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-navy text-center uppercase leading-tight mb-5" data-id="element-126">
          Si enseñás{' '}
          <span className="green-highlight" data-id="element-127">
            Acuicultura, Piscicultura o Producción Acuícola
          </span>
          , esto te va a sonar muy familiar:
        </h2>

        <div className="bg-white border-2 border-brand-navy rounded-lg p-4 md:p-5 brunson-shadow mb-5" data-id="element-128">
          <ul className="space-y-2.5" data-id="element-129">
            {points.map((p, i) => <li key={i} className="flex items-start gap-2" data-id="element-130">
                <span className="text-brand-red text-lg leading-none mt-0.5" data-id="element-131">
                  ❌
                </span>
                <p className="text-sm md:text-base text-brand-ink font-medium leading-snug" data-id="element-132">
                  {p}
                </p>
              </li>)}
          </ul>
        </div>

        <p className="text-center text-xl md:text-3xl font-display font-bold text-brand-orange uppercase" data-id="element-133">
          ¿Cuántos domingos más vale tu tiempo libre?
        </p>
      </div>
    </section>;
}